export const removeFromSessionStorage = (name) => {
	sessionStorage.removeItem(name)
}
